// imports
import '@babel/polyfill';
import '@babel/plugin-syntax-dynamic-import';
import * as conditioner from 'conditioner-core/conditioner-core.min';
window.conditioner = conditioner;
import './polyfill/arrayFrom';
import './polyfill/arrayFind';
import './polyfill/dataset';
// import cursor from './modules/cursor';
import { gsap } from "gsap";
import LocomotiveScroll from 'locomotive-scroll';
import barba from '@barba/core';

const container = document.body.querySelector('[data-scroll-container]');
const timeline = gsap.timeline();
const header = document.querySelector('#header');

// ios viewport
const appHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}
window.addEventListener('resize', appHeight);
appHeight();

const appear = (el) => {
    const els = el.querySelectorAll(".to-reveal");
    var d = 0;
    els.forEach((el) => {
        setTimeout(() => {
            el.classList.add('revealed');   
        }, d);

        var t = el.hasAttribute('data-delay') ? el.getAttribute('data-delay') : false;
        // if (isNaN(t)) {
            t = 100;
        // }
        d += t;
    });
}

window.addEventListener("load", () => {
    header.classList.add('inView');
    appear(header);

    let script = document.createElement('script');
    script.src = `https://cdn.cookielaw.org/scripttemplates/otSDKStub.js`;
    script.setAttribute('data-domain-script', 'c355e17c-f04b-4ff8-a581-c0035cc7cb5b-test');
    document.head.appendChild(script);
    window.OptanonWrapper = () =>{
        const cookie_cats = window.OnetrustActiveGroups;

            //Necessary
            if (!!cookie_cats.includes('C0001')) {
                console.log('Necessary cookie enabled');
            }

            //Performance
            if (!!cookie_cats.includes('C0002')) {
                console.log('Performance cookie enabled');
            }

            //Functional
            if (!!cookie_cats.includes('C0003')) {
                console.log('Functional cookie enabled');
            }

            //Targeting
            if (!!cookie_cats.includes('C0004')) {
                console.log('Targeting cookie enabled');
            // GA
            (function(w,d,s,i){var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s);j.async=true;j.src=
            'https://www.googletagmanager.com/gtag/js?id='+i;f.parentNode.insertBefore(j,f);
            })(window,document,'script','G-TX59P3GZB3');

            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-TX59P3GZB3');
            }

            //Social
            if (!!cookie_cats.includes('C0005')) {
                console.log('Social cookie enabled');
            }
    }
    
    // locomotive things
    initLocomotive();

    function initLocomotive() {
        window.locomotive = new LocomotiveScroll({
            el: container,
            smooth: true,
            offset: ['0', '0'],
            getDirection: true,
            initPosition: {
                x: 0,
                y: 0
            },
            lerp: 0.1,

            multiplier: 1,
            firefoxMultiplier: 50,
            touchMultiplier: 2,
            resetNativeScroll: !0,
            smartphone: {
                // smooth: true
            },
            tablet: {
                // smooth: true
                breakpoint: 1200
            },
        });

        setTimeout(() => {
            window.locomotive.update();
        }, 1000)

        locomotive.on('call', (func, args, obj) => {
            if (func == "inView") {
                appear(obj.el);
            }
        });

        locomotive.on('scroll', (args) => {
            if (args.direction == "down") {
                if (args.scroll.y > 1) {
                    header.classList.add('small');
                } else {
                    header.classList.remove('small');
                }
            } else {
                if (args.scroll.y < 80) {
                    header.classList.remove('small');
                } else {
                    header.classList.add('small');
                }
            }
        });
    }

    // barba transitions things
    barba.init({
        sync: true,
        transitions: [
        // default
        {
            async leave() {
                timeline
                    .to(document.body, { opacity: '0', duration: 0.5 });


                header.classList.remove('active');

                setTimeout(() => {
                    header.classList.add('no-transition');

                    setTimeout(() => {
                        header.classList.remove('small');
                    }, 1);

                    setTimeout(() => {
                        header.classList.remove('no-transition');
                    }, 10);
                }, 500)

                const done = this.async();
                await delay(1000);
                done();
            },
            enter() {
            },
            once() {
                conditioner.hydrate(document.documentElement);
                timeline.to(document.body, { opacity: '1', duration: 0.5 });
            }
        }
        ]
    });

    // update the scroll after entering a page
    barba.hooks.after(() => {
        locomotive.destroy();
        window.scrollTo(0, 0);
        initLocomotive();
        conditioner.hydrate(document.querySelector('main'));

    });

    barba.hooks.leave(() => {
    });

    barba.hooks.enter(() => {
        timeline.to(document.body, { opacity: '1', duration: 0.5 });
    })
});

function delay(n) {
    return new Promise((done) => {
        setTimeout(() => {
            done();
        }, n)
    })
}

document.documentElement.className = 'js';
conditioner.addPlugin({
    monitor: {
        name: 'visible',
        create: (context, element) => ({
            matches: false,
            addListener(change) {
                new IntersectionObserver((entries) => {
                        this.matches = entries.pop()
                            .isIntersecting === context;
                        change();
                    })
                    .observe(element);
            },
        }),
    },
    moduleSetName: (name) => `./modules/${name}.js`,
    moduleGetConstructor: (module) => module.default,
    moduleImport: (name) => import( /* webpackMode: "lazy" */ `${name}`),
});